import { axiosPost, axiosGet } from '../axios/config';
import { useAxiosPost } from '../hook/useAxios';

const prefix = '/admin/chat/';

export const getAdminCurrentUser = () => {
  return axiosGet('/admin/profile');
};

export const getAdminImage = () => {
  return axiosGet('/admin/profile-image');
};

export const updateAdminImage = (data) => {
  return axiosPost('/admin/profile-image', data);
};

export const adminUsersDelete = (data) => {
  return axiosPost('/admin/users', data);
};

export const adminUsersUpdate = (data) => {
  return axiosPost('/admin/users-update', data);
};

export const adminBusinessTypeUpdate = (data) => {
  return axiosPost('/admin/business-type-update', data);
};

export const getTokenForAdmin = (data) => {
  return axiosGet('/admin/get-token', data);
};

export const getCompanyList = (data) => {
  return axiosGet('/admin/company-list', data);
};

export const helpNotificationCheck = (user) => {
  return axiosGet('/admin/notification/help', user);
};

export const removeNotificationHighlightChat = async (data) => {
  const response = await axiosPost('/admin/remove-notification-highlight-chat', data);
  return response;
};

export const getAdminHelpRoom = () => {
  return axiosGet(prefix + 'get-rooms');
};

export const getAdminChatMessages = (data) => {
  return axiosGet(prefix + 'get-room-messages', data);
};

export const AdminImageUpload = (data) => {
  return axiosPost(prefix + 'image-upload', data);
};

export const deleteAdminRoomChat = (data) => {
  return axiosPost(prefix + 'delete-room-chat', data);
};

export const useGetCompanyWithUserApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const getCompanyWithUserApi = async (data) => {
    return callApi(`/admin/company-with-user`, data);
  };

  return { getCompanyWithUserApi, isLoading, isError, isSuccess };
};

export const useUpdateUserPasswordApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const updateUserPasswordApi = async (data) => {
    return callApi(`/admin/user-password-update`, data);
  };

  return { updateUserPasswordApi, isLoading, isError, isSuccess };
};

export const useUpdateAdminCompanyApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const updateAdminCompanyApi = async (data) => {
    return callApi(`/admin/company`, data);
  };

  return { updateAdminCompanyApi, isLoading, isError, isSuccess };
};

export const useSendReminderApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const sendReminderApi = async (data) => {
    return callApi(`/admin/send-reminder`, data);
  };

  return { sendReminderApi, isLoading, isError, isSuccess };
};

export const useSendReminderMailsApi = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const sendReminderMailsApi = async (data) => {
    return callApi(`/admin/send-reminder-mails`, data);
  };

  return { sendReminderMailsApi, isLoading, isError, isSuccess };
};
